import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DocumentGroupService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getDocumentGroup(payload) {
		return this._http.get(this.baseUrl + '/admin/optionses/', { params: payload.params });
	}

	addDocumentGroup(payload) {
		return this._http.post(this.baseUrl + '/admin/optionses/', payload.body);
	}

	updateDocumentGroup(payload) {
		return this._http.put(`${this.baseUrl}/admin/optionses/${payload.optionTypeId}/`, payload.body);
	}

	deleteDocumentGroup(payload) {
		return this._http.delete(`${this.baseUrl}/admin/optionses/${payload.optionTypeId}/`);
	}
}
